import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { Formik, Form, Field } from 'formik';

import { getClientSkills, editClientUser, getClientUserSkills, addClientUserSkills, removeClientUserSkills } from '../utils/Api'
import { handleLoaderEvent } from '../utils/LoaderEmitter';

import * as Yup from 'yup';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import '../styles/EditClientUser.css';


const EditClientUser = ({ user, userUpdated, showEditOption }) => {

  const [editModalShow, setEditModalShow] = useState(false);
  const [editSkillModalShow, setEditSkillModalShow] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [availableSkills, setAvailableSkills] = useState([]);
  const [clientUserSkills, setClientUserSkills] = useState();
  const [addClientSkillStatus, setAddClientSkillStatus] = useState();

  let { id } = useParams();

  useEffect(() => {
    (async () => {
      refreshClientSkills();
      setUserDetails(user);
    })();
  }, [id, addClientSkillStatus]);

  const refreshClientSkills = async () => {
    let clientSkills = await getClientSkills(id);
    let clientUserAssignedSkills = await getClientUserSkills(user.id);
    if (!clientUserAssignedSkills) {
      return;
    }
    let clientSkillList = clientSkills?.skillList;
    let userAssignedSkillList = clientUserAssignedSkills ? clientUserAssignedSkills?.skillList : [];
    let selectedSkill = [];
    let availableSkill = [];
    clientSkillList.map((skill) => {
      let isExist = userAssignedSkillList.filter(item => {
        return item['id'] == skill['id'];
      });

      if (!isExist.length) {
        availableSkill.push({ value: skill, label: skill['skillName'] });
      } else {
        let detail = isExist[0];
        selectedSkill.push({ value: detail, label: detail['skillName'] })
      }
    });
    setSelectedSkill(selectedSkill);
    setClientUserSkills(clientUserAssignedSkills.skillList)
    setAvailableSkills(availableSkill);
  }

  const editModalHandleClose = () => {
    setEditModalShow(false);
  }

  const editSkillModalHandleClose = () => {
    setAddClientSkillStatus(false);
    setEditSkillModalShow(false);
  }

  const editModalHandleShow = (details) => {
    setEditModalShow(true);
  }

  const editSkillModalHandleShow = () => {
    setEditSkillModalShow(true);
  }

  const skillsAssignedCol = (skillAssigned) => {
    let noOfSkills = skillAssigned?.length;
    if (noOfSkills > 0) {
      return skillAssigned?.map((skill, id) => {
        return (
          <>
            <span id={skill?.skillid} key={skill.skillid} className="p-1">
              {skill?.skillName}{id === noOfSkills - 1 ? <span></span> : <span>,</span>}
            </span>
          </>
        )
      });
    }
    else {
      return (<>
        Skill  Not Assigned
      </>);
    }
  }

  const updateUserSkill = async (skill) => {
    handleLoaderEvent.emit('loader', true);
    let params = {
      "customer_id": id,
      "subscription_product_skill_id": skill?.subscriptionProductSkillId
    };
    let addedClientUserSkills = await addClientUserSkills(userDetails.id, params);
    if (!addedClientUserSkills) {
      return;
    }
    refreshClientSkills();
    toast.info('Skill added to user successfully');
    handleLoaderEvent.emit('loader', false);
  }

  const removeUserSkill = async (skill) => {
    handleLoaderEvent.emit('loader', true);
    let params = {
      "customer_id": id,
      "subscription_product_skill_id": skill?.subscriptionProductSkillId
    };
    let removedClientSkills = await removeClientUserSkills(userDetails.id, params);
    if (!removedClientSkills) {
      return;
    }
    refreshClientSkills();
    toast.info('Skill removed from user successfully');
    handleLoaderEvent.emit('loader', false);
  }

  const onSkillChange = (
    newValue,
    actionMeta
  ) => {
    switch (actionMeta.action) {
      case 'remove-value':
        removeUserSkill(actionMeta['removedValue']['value']);
        break;
      case 'select-option':
        updateUserSkill(actionMeta['option']['value']);
        break;
    }
  }

  const handleSubmit = async (values) => {
    handleLoaderEvent.emit('loader', true);
    let params = {
      department: values.department,
      email: values.email,
      firstName: values.firstName,
      id: userDetails.id,
      lastName: values.lastName,
      loginType: "EMAIL"
    };
    let editedClientUser = await editClientUser(id, userDetails.id, params);
    if (!editedClientUser) {
      return;
    }
    setEditModalShow(false);
    userUpdated(true);
    handleLoaderEvent.emit('loader', false);
    toast.info("User details updated successfully");
  };

  const addUserSchema = Yup.object().shape({
    firstName: Yup.string().min(3, 'First Name should be atleast 3 characters').required('First Name is Required'),
    lastName: Yup.string().min(3, 'Last Name should be atleast 3 characters').required('Last Name is Required'),
    department: Yup.string().min(3, 'Department should be atleast 3 characters').required('Department is Required'),
    email: Yup.string().email('Enter valid email id').required('Email is Required'),
  });

  return (
    <>
      <tr className="table-content border-bottom table-row" key={user?.id}>
        <td style={{ width: '15%' }} className="p-3">{user?.first_name + " " + user?.last_name}{user?.user_roles.length>0 && user?.user_roles[0]['roles']['role_key'] === "CUSTOMER_ADMIN" ? <span className="badge rounded-pill bg-success ms-2 p-1 px-2"> Admin</span> : ""}</td>
        <td style={{ width: '10%' }}>{user?.department || 'Department Not Assigned'}</td>
        <td style={{ width: '15%' }}>{user?.email}</td>
        <td style={{ width: '40%' }}>{skillsAssignedCol(clientUserSkills)}</td>
        <td style={{ width: '30%' }} className='actions p-3'>
          {showEditOption &&
            <button type='button' className={ user?.user_roles.length>0 && user?.user_roles[0]['roles']['role_key'] === "CUSTOMER_ADMIN" ? " edit-button-disabled px-3" : " edit-button px-3"} onClick={() =>  user?.user_roles.length>0 && user?.user_roles[0]['roles']['role_key'] === "CUSTOMER_ADMIN" ? toast.info("Admin information cannot be updated") : editModalHandleShow(userDetails)}>{"Edit"}</button>
          }
          <button type='button' className={user?.user_roles.length>0 && user?.user_roles[0]['roles']['role_key'] === "CUSTOMER_ADMIN" ? " edit-button-disabled px-3 ms-3" : " edit-button px-3 ms-3"} onClick={() => user?.user_roles.length>0 &&  user?.user_roles[0]['roles']['role_key'] === "CUSTOMER_ADMIN" ? toast.info("Admin skills cannot be updated") : editSkillModalHandleShow(userDetails)}>{"Manage Skills"}</button>
        </td>
      </tr>

      <Modal className='edit-modal' show={editModalShow} onHide={editModalHandleClose}>
        <Modal.Body>
          <Modal.Title>Edit User</Modal.Title>
          <Formik
            initialValues={{
              firstName: userDetails?.first_name,
              lastName: userDetails?.last_name,
              email: userDetails?.email,
              department: userDetails?.department
            }}
            validationSchema={addUserSchema}
            onSubmit={values => {
              handleSubmit(values);
            }}
          >
            {({ errors, touched }) => (
              <Form>
                <div className='row p-0 m-0 w-100'>
                  <div className='col-6 ps-0 pe-3 mt-4'>
                    <div className='new-input position-relative'>
                      <Field name="firstName" type="text" />
                      <span className="floating-label">First Name</span>
                      {errors.firstName && touched.firstName ? (
                        <div className="invalid-text">{errors.firstName}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className='col-6 ps-3 pe-0 mt-4'>
                    <div className='new-input position-relative'>
                      <Field name="lastName" type="text" />
                      <span className="floating-label">Last Name</span>
                      {errors.lastName && touched.lastName ? (
                        <div className="invalid-text">{errors.lastName}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className='col-6 ps-0 pe-3 mt-4'>
                    <div className='new-input position-relative'>
                      <Field name="department" type="text" />
                      <span className="floating-label">Department</span>
                      {errors.department && touched.department ? (
                        <div className="invalid-text">{errors.department}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className='col-6 ps-3 pe-0 mt-4'>
                    <div className='new-input position-relative'>
                      <Field name="email" type="email" disabled={true} />
                      <span className="floating-label">Email Id</span>
                      {errors.email && touched.email ? <div className="invalid-text">{errors.email}</div> : null}
                    </div>
                  </div>
                </div>
                <div className='d-flex justify-content-center mt-5'>
                  <button type="button" className='cancel-button p-2 px-4 me-3' onClick={editModalHandleClose}>Cancel</button>
                  <button type="submit" className='save-button p-2 px-4'>Save</button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      <Modal className='edit-modal' show={editSkillModalShow} onHide={editSkillModalHandleClose}>
        <Modal.Body>
          <Modal.Title className="ms-2 ps-1">
            Manage Skills
          </Modal.Title>
          <div className='container mt-3'>
            <Select isMulti='true' isClearable='false'
              defaultValue={selectedSkill}
              onChange={onSkillChange}
              options={availableSkills}
            />
            <div className="pt-5"></div>
            <div className='d-flex justify-content-center mt-5'>
              <button className='save-button p-2 px-4' onClick={editSkillModalHandleClose}>Close</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
};

export default EditClientUser;